<template>
    <div class="unpublish-container">
        <div class="unpublish-title">
            <DsIconButton @click="closeUnpublish">
                <ds-icon
                    name="x"
                />
            </DsIconButton>
            <h4>{{ $t('funnel.unpublish.analysis.title') }}</h4>
        </div>
        <div class="unpublish-analysis-info">
            <DsListItem
                :title="landingPages.landingPageCount > 1 ? `${landingPages.landingPageCount} ${$t(landingPages.message)}` : $t(landingPages.message)"
            >
                <template #leading>
                    <DsIcon
                        :name="landingPages.nameIcon"
                        class="unpublish-check-icon"
                        :class="[{ 'unpublish-alert-icon': hasLandingPages }]"
                    />
                </template>
            </DsListItem>

            <DsListItem
                :title="webForms.webFormCount > 1 ? `${webForms.webFormCount} ${$t(webForms.message)}` : $t(webForms.message)"
            >
                <template #leading>
                    <DsIcon
                        :name="webForms.nameIcon"
                        class="unpublish-check-icon"
                        :class="[{ 'unpublish-alert-icon': hasWebForms }]"
                    />
                </template>
            </DsListItem>
        </div>
        <div v-if="hasWebForms || hasLandingPages" class="unpublish-warning-info" data-qa="unpublish-warning-info">
            <div class="unpublish-warning-info-title">
                <DsIcon name="alert-circle" />
                <strong>{{ $t('funnel.unpublish.analysis.options.title') }}</strong>
            </div>
            <div class="unpublish-warning-info-description">
                <span>{{ $t('funnel.processing.cancelled.unpublished.message.default') }}</span>
                <span>{{ $t('funnel.unpublish.analysis.options.description') }}</span>
            </div>
        </div>
        <div class="button-row-unpublish">
            <DsTextButton
                class="cancel-button"
                @click="closeUnpublish"
            >
                {{ $t('funnel.edit.cancel') }}
            </DsTextButton>

            <DsFilledButton
                class="unpublish-button"
                @click="unpublish"
            >
                {{ $t('funnel.edit.unpublish') }}
            </DsFilledButton>
        </div>
    </div>
</template>

<script>
import { analyzeLandingPages, analyzeWebForms } from './unpublish.util';

export default {
    props: {
        draftJson: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['close-unpublish', 'unpublish'],
    data() {
        return {
            landingPages: {},
            webForms: {},
            isPublished: false,
        };
    },

    computed: {
        hasWebForms() {
            return this.webForms.webFormCount > 0;
        },

        hasLandingPages() {
            return this.landingPages.landingPageCount > 0;
        },
    },

    beforeMount() {
        this.loadUnpublishInfo();
    },

    methods: {
        loadUnpublishInfo() {
            this.landingPages = analyzeLandingPages(this.draftJson);
            this.webForms = analyzeWebForms(this.draftJson);
        },

        closeUnpublish() {
            this.$emit('close-unpublish');
        },

        unpublish() {
            this.$emit('unpublish');
        },
    },
};

</script>

<style lang="scss" scoped>
.unpublish-container {
    height: 100%;
    width: px-to-rem(450);
    z-index: 1000;
    background-color: $color-paper;
    transition: right .5s;
    position: fixed;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 px-to-rem(10) rgba(0,0,0,0.2);
}

.unpublish-title {
    padding: 0.90rem;
    border-bottom: px-to-rem(0.5) solid $color-gray-200;
    display: inline-flex;
}

.unpublish-title > h4 {
    font-weight: 400;
    padding-top: $spacing-150;
}

div.button-row-unpublish {
    padding-top: $spacing-250;
    padding-bottom: $spacing-250;
    box-shadow: rgba(0, 0, 0, 0.2) 0 px-to-rem(-6) px-to-rem(6) px-to-rem(-6);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: $color-paper;
}

div.button-row-unpublish > button.button.cancel-button.text-button {
    margin-left: $spacing-200;
}

.unpublish-check-icon {
    fill: $color-green-400;
}

.unpublish-alert-icon {
    fill: $color-orange-500;
}

.unpublish-warning-info {
    background-color: $color-gray-100;
    margin: $spacing-250;
    padding: $spacing-125;
    border-radius: px-to-rem(10);
}

.unpublish-warning-info-title {
    display: flex;
    align-items: center;
}

.unpublish-warning-info-description {
    margin-left: $spacing-400;
    margin-top: $spacing-125;
    display: inline-grid;
}
</style>

<style lang="scss">
.unpublish-container {
    div.unpublish-analysis-info div.list-item-info {
        padding-bottom: 0;
    }

    div.unpublish-warning-info > div > svg {
        color: $color-ink-600;
        margin-right: $spacing-125;
    }
}
</style>
